import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import "@/assets/fontIcon/css/font-awesome.min.css"
import service from "@/service"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import MetaInfo from 'vue-meta-info';
Vue.use(MetaInfo);

Vue.use(ElementUI)

function setDocumentTitle(title){
   var body = document.getElementsByTagName('body')[0];
   document.title = title;
   var iframe = $("<iframe style='display:none;'></iframe>");
   iframe.on('load',function() {
      setTimeout(function() {
         iframe.off('load').remove();
      }, 0);
   }).appendTo(body);
}

Vue.prototype.$BUS = new Vue()


function getBeforeDate(dayNum, fmt) {
   let str = ""
   let time = new Date().getTime() - 24 * dayNum * 60 * 60 * 1000;
   let date = new Date(time)
   let year = date.getFullYear()
   let month = date.getMonth() + 1
   let day = date.getDate()
   month = month > 9 ?  month + '' : '0' + month
   day = day > 9 ?  day + '' : '0' + day
   if(fmt === 'yyyy-MM-dd'){
      str = `${year}-${month}-${day}`
   }else {
      str = `${year}${month}${day}`
   }
   return str;
}

function timeFormate(value){
    if(value){
        value = value.toString().replace(/[^\d]/g, '')
        let date = new Date(value * 1000)
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()
        let hour = date.getHours()
        let minutes = date.getMinutes()
        let seconds = date.getSeconds()
        month = month > 9 ? month + '' : '0' + month
        day = day > 9 ? day + '' : '0' + day
        hour = hour > 9 ? hour + '' : '0' + hour
        minutes = minutes > 9 ? minutes + '' : '0' + minutes
        seconds = seconds > 9 ? seconds + '' : '0' + seconds
        return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`
    }else {
        return ""
    }
    
}

function getDWTypeByName(name) {
   name = name.toUpperCase();
   if (name.length == 4) name = name + "X";
   //一字定
   if (name.match("\\dXXXX")) {
       return parseInt(name[0]) + 1;
   } else if (name.match("X\\dXXX")) {
       return parseInt(name[1]) + 15;
   } else if (name.match("XX\\dXX")) {
       return parseInt(name[2]) + 29;
   } else if (name.match("XXX\\dX")) {
       return parseInt(name[3]) + 43;
   } else if (name.match("XXXX\\d")) {
       return parseInt(name[4]) + 57;
   }
   //二字定
   else if (name.match("\\d{2}XXX")) {
       return 108 + parseInt(name[0]) * 10 + parseInt(name[1]);
   } else if (name.match("\\dX\\dXX")) {
       return 208 + parseInt(name[0]) * 10 + parseInt(name[2]);
   } else if (name.match("\\dXX\\dX")) {
       return 308 + parseInt(name[0]) * 10 + parseInt(name[3]);
   } else if (name.match("\\dXXX\\d")) {
       return 408 + parseInt(name[0]) * 10 + parseInt(name[4]);
   } else if (name.match("X\\d{2}XX")) {
       return 508 + parseInt(name[1]) * 10 + parseInt(name[2]);
   } else if (name.match("X\\dX\\dX")) {
       return 608 + parseInt(name[1]) * 10 + parseInt(name[3]);
   } else if (name.match("X\\dXX\\d")) {
       return 708 + parseInt(name[1]) * 10 + parseInt(name[4]);
   } else if (name.match("XX\\d{2}X")) {
       return 808 + parseInt(name[2]) * 10 + parseInt(name[3]);
   } else if (name.match("XX\\dX\\d")) {
       return 908 + parseInt(name[2]) * 10 + parseInt(name[4]);
   } else if (name.match("XXX\\d\\d")) {
       return 1008 + parseInt(name[3]) * 10 + parseInt(name[4]);
   }
   //三字定
   else if (name.match("\\d{3}XX")) {
       return 1108 + parseInt(name[0]) * 100 + parseInt(name[1]) * 10 + parseInt(name[2]);
   } else if (name.match("\\d{2}X\\dX")) {
       return 2108 + parseInt(name[0]) * 100 + parseInt(name[1]) * 10 + parseInt(name[3]);
   } else if (name.match("\\d{2}XX\\d")) {
       return 3108 + parseInt(name[0]) * 100 + parseInt(name[1]) * 10 + parseInt(name[4]);
   } else if (name.match("\\dX\\d{2}X")) {
       return 4108 + parseInt(name[0]) * 100 + parseInt(name[2]) * 10 + parseInt(name[3]);
   } else if (name.match("\\dX\\dX\\d")) {
       return 5108 + parseInt(name[0]) * 100 + parseInt(name[2]) * 10 + parseInt(name[4]);
   } else if (name.match("\\dXX\\d{2}")) {
       return 6108 + parseInt(name[0]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
   } else if (name.match("X\\d{3}X")) {
       return 7108 + parseInt(name[1]) * 100 + parseInt(name[2]) * 10 + parseInt(name[3]);
   } else if (name.match("X\\d{2}X\\d")) {
       return 8108 + parseInt(name[1]) * 100 + parseInt(name[2]) * 10 + parseInt(name[4]);
   } else if (name.match("X\\dX\\d{2}")) {
       return 9108 + parseInt(name[1]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
   } else if (name.match("XX\\d{3}")) {
       return 10108 + parseInt(name[2]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
   }
   //四
   else if (name.match("\\d{4}X")) {
       return 11108 + parseInt(name[0]) * 1000 + parseInt(name[1]) * 100 + parseInt(name[2]) * 10 + parseInt(name[3]);
   } else if (name.match("\\d{3}X\\d")) {
       return 21108 + parseInt(name[0]) * 1000 + parseInt(name[1]) * 100 + parseInt(name[2]) * 10 + parseInt(name[4]);
   } else if (name.match("\\d{2}X\\d{2}")) {
       return 31108 + parseInt(name[0]) * 1000 + parseInt(name[1]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
   } else if (name.match("\\dX\\d{3}")) {
       return 41108 + parseInt(name[0]) * 1000 + parseInt(name[2]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
   } else if (name.match("X\\d{4}")) {
       return 51108 + parseInt(name[1]) * 1000 + parseInt(name[2]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
   }
   return 0;
}

function floatAdd(arg1, arg2) {
   var r1, r2, m;
   try {
       r1 = arg1.toString().split(".")[1].length
   } catch (e) {
       r1 = 0
   }
   try {
       r2 = arg2.toString().split(".")[1].length
   } catch (e) {
       r2 = 0
   }
   return m = Math.pow(10, Math.max(r1, r2)), parseFloat(((arg1 * m + arg2 * m) / m).toFixed(5));
}

Vue.filter('timeFormate', timeFormate)

//加法
Vue.prototype.$accAdd = function(arg1, arg2){
    var r1, r2, m, c;
    try {
        r1 = arg1.toString().split(".")[1].length;
    }
    catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split(".")[1].length;
    }
    catch (e) {
        r2 = 0;
    }
    c = Math.abs(r1 - r2);
    m = Math.pow(10, Math.max(r1, r2));
    if (c > 0) {
        var cm = Math.pow(10, c);
        if (r1 > r2) {
            arg1 = Number(arg1.toString().replace(".", ""));
            arg2 = Number(arg2.toString().replace(".", "")) * cm;
        } else {
            arg1 = Number(arg1.toString().replace(".", "")) * cm;
            arg2 = Number(arg2.toString().replace(".", ""));
        }
    } else {
        arg1 = Number(arg1.toString().replace(".", ""));
        arg2 = Number(arg2.toString().replace(".", ""));
    }
    return (arg1 + arg2) / m;
  }
  
  //减法
  Vue.prototype.$accSub = function(arg1, arg2){
    var r1, r2, m, n;
    try {
        r1 = arg1.toString().split(".")[1].length;
    }
    catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split(".")[1].length;
    }
    catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
    n = (r1 >= r2) ? r1 : r2;
    return ((arg1 * m - arg2 * m) / m).toFixed(n);
  }
  
  //乘法
  Vue.prototype.$accMul = function(arg1, arg2) {
    var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
    try {
        m += s1.split(".")[1].length;
    }
    catch (e) {
    }
    try {
        m += s2.split(".")[1].length;
    }
    catch (e) {
    }
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
  }
  
  //除法
  Vue.prototype.$accDiv = function(arg1, arg2){
    var t1 = 0, t2 = 0, r1, r2;
    try {
        t1 = arg1.toString().split(".")[1].length;
    }
    catch (e) {
    }
    try {
        t2 = arg2.toString().split(".")[1].length;
    }
    catch (e) {
    }
        r1 = Number(arg1.toString().replace(".", ""));
        r2 = Number(arg2.toString().replace(".", ""));
        return (r1 / r2) * Math.pow(10, t2 - t1);
  }

Vue.prototype.$getBeforeDate = getBeforeDate

Vue.prototype.$setDocumentTitle = setDocumentTitle

Vue.prototype.$getDWTypeByName = getDWTypeByName

Vue.prototype.$floatAdd = floatAdd

Vue.prototype.$http = service

//集合去掉重复
Array.prototype.uniquelize = function () {
    var tmp = {},
        ret = [];
    for (var i = 0, j = this.length; i < j; i++) {
        if (!tmp[this[i]]) {
            tmp[this[i]] = 1;
            ret.push(this[i]);
        }
    }

    return ret;
}

///集合取交集
Array.intersect = function () {
    var result = new Array();
    var obj = {};
    for (var i = 0; i < arguments.length; i++) {
        for (var j = 0; j < arguments[i].length; j++) {
            var str = arguments[i][j];
            if (!obj[str]) {
                obj[str] = 1;
            }
            else {
                obj[str]++;
                if (obj[str] == arguments.length) {
                    result.push(str);
                }
            }//end else
        }//end for j
    }//end for i
    return result;
}

Vue.config.productionTip = false

router.beforeEach(async function (to, from, next) {
   var paramsKeys = Object.keys(to.query)
   for (let i of paramsKeys) {
      if (to.query[i]) {
         sessionStorage.setItem(i, to.query[i])
      }
   }

   let userInfo = sessionStorage.getItem("userInfo")
   if(userInfo){
      store.state.userInfo = JSON.parse(userInfo)
   }
   let result = await service.postAxiosMethod("/sysInfo")
   let isSearch, status
   if (result.code == 0 && result.msg == "success") {
      sessionStorage.setItem('title', result.data.sysTitle)
      sessionStorage.setItem('noticeTitle', result.data.noticeTitle)
      sessionStorage.setItem('noticeContent', result.data.noticeContent)
      isSearch = result.data.isSearch
      status = result.data.status
   }

   let token = sessionStorage.getItem('token')
   if ((token == "" || !token) && status == 1) {
      if (isSearch == 1) {
         if (to.path !== '/') {
            next('/')
         }
      } else {
         if (to.path !== '/login') {
            next('/login')
         }
      }
   } else {
      if (!userInfo) {
         if (to.path !== "/login") {
            next("/login")
         }
      } else {
         if(to.path !== "/userAgreement"){
            if (to.path !== "/index") {
               next("/index")
            }
         }
         
      }
   }
   next()
})


new Vue({
   router,
   store,
   render: h => h(App)
}).$mount('#app')
